module.exports = __webpack_public_path__ + "img/pic_hushoushuang2.1222ee31.png";